export var findRouteIndex = function (routes, path) {
    var index = routes.findIndex(function (route) { return route.path === path; });
    if (index !== -1)
        return index;
    return routes.reduce(function (acc, route) {
        return acc !== -1 ? acc : findRouteIndex(route.children || [], path);
    }, -1);
};
